import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateContactLead, privateContactLeadsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IByPrivateContactLeadState } from './types';

const PRIVATE_CONTACT_LEAD_MODULE = 'privateContactLead';

const state: IByPrivateContactLeadState = {
    byLead: new Map()
};

const dataObjectModule = getDataObjectsModule<IPrivateContactLead>(privateContactLeadsManager, 3);
const searchModule = getSearchModule<IPrivateContactLead>(privateContactLeadsManager);

const privateContactLeadModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, mutations, getters });
store.registerModule(PRIVATE_CONTACT_LEAD_MODULE, privateContactLeadModuleInstance);

export { PRIVATE_CONTACT_LEAD_MODULE };
